import { merge } from 'lodash';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as impactAssessmentThresholdTypes from './impactAssessmentThresholdTypes';

const byId = handleActions(
  {
    [impactAssessmentThresholdTypes.IMPACT_ASSESSMENT_THRESHOLD_LIST.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.impactAssessmentThresholds),
  },
  {},
);

const allIds = handleActions(
  {
    [impactAssessmentThresholdTypes.IMPACT_ASSESSMENT_THRESHOLD_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
